import { useAbility } from "@/lib/casl/ability-context";
import { useInternalOpsChannels } from "@/lib/api/internal-ops-messaging";
import { useFeatureFlagEnabled } from "@posthog/react";

export const useShouldShowFloatingChat = () => {
  const isMentorOpsSupportEnabled = useFeatureFlagEnabled(
    "enable-mentor-ops-support",
  ) || import.meta.env.DEV;
  const ability = useAbility();
  const canReadInternalChannels =
    ability.can("read", "internal-channels") && !!isMentorOpsSupportEnabled;
  const { data: internalChannels } = useInternalOpsChannels(
    canReadInternalChannels,
  );

  return (
    canReadInternalChannels && (internalChannels?.length ?? 0) > 0
  );
};
